import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const PageNotFound = () => {
  useEffect(() => {
    document.title = "Page Not Found";
  });
  return (
    <div>
      <h1 style={{ textAlign: "center", fontSize: "100px" }}>Page not Found</h1>
      <Link to="/">
        <h1 style={{ textAlign: "center", fontSize: "50px", color: "green" }}>
          Go to Home Page
        </h1>
      </Link>
      <Link to="/admin">
        <h1 style={{ textAlign: "center", fontSize: "50px", color: "green" }}>
          Go to Admin Page
        </h1>
      </Link>
    </div>
  );
};

export default PageNotFound;
